import React from 'react';
import CountUp from 'react-countup';

const CountUpComponent = ({ targetValue, start = 0, duration = 2.5, ...props }) => {
    return (
        <CountUp start={start} end={targetValue} duration={duration} {...props} />
    );
};

export default CountUpComponent;
